export default __webpack_public_path__ + "static/media/icon-master-24px.316280c8.svg";